import React from 'react'
import { getClientSettings } from '../../auth/services/auth.service'
import { UserManager } from 'oidc-client'
import { Container, Alert } from 'react-bootstrap'
import { CircleSpinner, CookieType, logError, logEvent } from 'shared/index'
import { appRoutes } from '../constants/routes'
import { useTranslation } from 'react-i18next'


function CallbackPage() {
	const [error, setError] = React.useState<Error>()
	const { t } = useTranslation()

	React.useEffect(
		() => {
			signin()
		},
		// eslint-disable-next-line
		[],
	)

	async function signin() {
		const userManager = new UserManager(getClientSettings('query'))
		try {
			if (window.location.search.indexOf('code') === -1) {
				logEvent(`Logging in without code SSP`, {
					user: await userManager.getUser(),
				})
				let redirect = sessionStorage.getItem(CookieType.RedirectUrl)
				if (redirect === null || redirect === '')
					sessionStorage.setItem(CookieType.RedirectUrl, '/')

				userManager.signinRedirect()
				return
			} else if (window.location.search.indexOf('code') > -1) {
				let value =
					sessionStorage.getItem(CookieType.RedirectUrl) ??
					appRoutes.startpage
				logEvent(`Logging in via SSP value: ` + value, {
					user: await userManager.getUser(),
				})
				//await userManager.signinCallback().then(async () => {
				await userManager.signinRedirectCallback().then(async () => {
					window.location.replace(value)
				})
			}
		} catch (error: any) {
			logError(error)
			setError(error)
		}
	}

	return (
		<Container className="d-flex justify-content-center align-items-center vh-100 callback">
			{error ? (
				<Alert
					variant="danger"
					dismissible
					onClose={() => setError(undefined)}>
					{(error.message.indexOf("iat is in the future") !== -1 || error.message.indexOf("exp is in the past") !== -1) ? t('TimeSyncError') : error.message }
				</Alert>
			) : (
				<CircleSpinner />
			)}
		</Container>
	)
}

export default CallbackPage
